import moment, { Moment, unitOfTime } from 'moment';
import { Nullable } from 'types';

export const ISO_FORMAT = 'YYYY-MM-DD';
export const US_LOCALE_DATE_FORMAT = 'MM/DD/YYYY';
export const TIME_12_HOUR_FORMAT = 'hh:mm a';
export const TIME_24_HOUR_FORMAT = 'HH:mm:ss';
export const MONTH_DAY = 'MMM D';

type NullableDate = Nullable<string | Moment | Date>;

const date = {
  // Preferred format to send to Back-end: YYYY-MM-DD
  toISO: (d: NullableDate) => moment(d).format(ISO_FORMAT),

  // Preferred format to display on Front-end: MM/DD/YYYY
  toUSLocale: (d: NullableDate) => moment(d).format(US_LOCALE_DATE_FORMAT),

  toMonthDay: (d: NullableDate) => moment(d).format(MONTH_DAY),

  getMomentObject: (d?: string | Moment | Date): Nullable<Moment> =>
    d ? moment(d) : null,

  getTime: (d: NullableDate) => moment(d).format(TIME_12_HOUR_FORMAT),

  getTime24(date: NullableDate) {
    return date ? moment(date).format(TIME_24_HOUR_FORMAT) : null;
  },

  diff(
    dateA: moment.MomentInput,
    dateB: moment.MomentInput,
    unit: unitOfTime.Diff,
  ): number {
    const now = moment(dateA);
    const end = moment(dateB);

    return now.diff(end, unit);
  },
};

export default date;
